import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import Select from 'react-select'
import {pays} from '../../../../../components/Data'
import {transformToValueLabel} from "../../../../../components/helpers";

interface adresseProps {
  // demandeId: string | number | null | undefined
  clientData: any
  clientAdresses?: any
  contactedBy?: any
  // demandeClient?: any
  contentCommunication?: any
  radioValue?: string | null | undefined
  isAdresseUpdated?: boolean | null | undefined
  setIsAdresseUpdated?: any
  updatedAdresseLivInfo?: any
  setUpdatedAdresseLivInfo?: any
  updatedAdresseFactInfo?: any
  setUpdatedAdresseFactInfo?: any
  errorsFac?: any
  errorsLiv?: any
  // isConfirmEdit?: boolean
  fromDemandeForm?: boolean
  isDisabled?: boolean
  isCreateOrUpdate?: boolean
  loadingAdresse?: boolean
  retraitDepot?: boolean
  setRetraitDepot?: any
  setPanier?: any
  setInitialPieces?: any
  loadingDepot?: boolean
  setClientAdresseEdit?: any
  livraisonSelectedValue?: any
  setLivraisonSelectedValue?: any
  facturationSelectedValue?: any
  setFacturationSelectedValue?: any
  clientAdresseData?: any
}

const AdresseClient = ({
    clientData,
    clientAdresses,
    isAdresseUpdated,
    setIsAdresseUpdated,
    updatedAdresseLivInfo,
    setUpdatedAdresseLivInfo,
    updatedAdresseFactInfo,
    setUpdatedAdresseFactInfo,
    errorsFac,
    errorsLiv,
    fromDemandeForm,
    isDisabled = false,
    isCreateOrUpdate = false,
    loadingAdresse,
    retraitDepot,
    setRetraitDepot,
    setPanier,
    setInitialPieces,
    loadingDepot = false,
    setClientAdresseEdit,
    livraisonSelectedValue,
    setLivraisonSelectedValue,
    facturationSelectedValue,
    setFacturationSelectedValue,
    clientAdresseData
  }: adresseProps) => {
    const [showAdresses, setShowAdresses] = useState<boolean>(false)

    const adresseLivraisonOptions = clientAdresses?.filter((adresse) => adresse.livraison === true)
    const adresseFacturationOptions = clientAdresses?.filter((adresse) => adresse.facturation === true)

    const handleAdressLivChange = (
      e: React.ChangeEvent<HTMLInputElement> | any,
      field?: string
    ) => {
      if (!setUpdatedAdresseLivInfo) return

      // cas input classique
      if (e?.target) {
        const {name, value} = e.target

        setUpdatedAdresseLivInfo((prev) => ({
          ...prev,
          [name]: value,
          edited: true

        }))
      }
      // cas react-select
      else if (field) {
        setUpdatedAdresseLivInfo((prev) => ({
          ...prev,
          [field]: e?.label || '',
          edited: true

        }))
      }
    }

    const handleAdressFactChange = (
      e: React.ChangeEvent<HTMLInputElement> | any,
      field?: string
    ) => {
      if (!setUpdatedAdresseFactInfo) return
      // cas input classique
      if (e?.target) {
        const {name, value} = e.target

        setUpdatedAdresseFactInfo((prev) => ({
          ...prev,
          [name]: value,
          edited: true
        }))
      }
      // cas react-select
      else if (field) {
        setUpdatedAdresseFactInfo((prev) => ({
          ...prev,
          [field]: e?.label || '',
          edited: true
        }))
      }
    }

    // Donnée à afficher par défaut
    // Fonctionnement:
    // Si le client n'a pas d'adresse Client, prendre les adresses du fiche client
    // Si le client a des adresses dans clientAdresse mais pas d'adresse de facturation ni livraison
    // Alors prendre celui du fiche client
    // Si l'une des deux adresses est absentes dans ClientAdresse
    // Alors prendre celui de la facturation ou de la livraison
    useEffect(() => {
      // Initialisation vide
      setUpdatedAdresseFactInfo({
        id: '',
        adresseFac: '',
        complementAdresseFac: '',
        telephoneFac: '',
        cPFac: '',
        villeFac: '',
        paysFac: '',
      })
      // Prendre ClientData comme source d'adresse
      if (clientAdresses?.length == 0) {
        if (!setUpdatedAdresseFactInfo) return

        setUpdatedAdresseFactInfo({
          id: '',
          adresseFac: clientData?.adresse,
          complementAdresseFac: clientData?.complementAdresse || '',
          telephoneFac: clientData?.telephone || '',
          cPFac: clientData?.codePostal || '',
          villeFac: clientData?.ville || '',
          paysFac: clientData?.pays?.nom || '',
        })
      } else {
        if (!setUpdatedAdresseFactInfo) return

        if (adresseFacturationOptions?.length !== 0) {
          //Récuperation de la dernière adresse
          const lastAdresse = (clientAdresseData && clientAdresseData?.facturation)
            ? clientAdresseData
            : adresseFacturationOptions?.at(-1)

          if (setFacturationSelectedValue) setFacturationSelectedValue(transformToValueLabel(lastAdresse))

          setUpdatedAdresseFactInfo({
            id: lastAdresse?.id || '',
            adresseFac: lastAdresse?.adresse || '',
            complementAdresseFac: lastAdresse?.complementAdresse || '',
            telephoneFac: lastAdresse?.telephone || '',
            cPFac: lastAdresse?.codePostal || '',
            villeFac: lastAdresse?.ville || '',
            paysFac: lastAdresse?.pays?.nom || '',
          })
        } else {
          // S'il n'y a pas d'adresse de livraison
          // alors mettre celui du client dans l'adresse de facturation
          if (adresseLivraisonOptions?.length == 0) {
            setUpdatedAdresseFactInfo({
              id: '',
              adresseFac: clientData?.adresse,
              complementAdresseFac: clientData?.complementAdresse || '',
              telephoneFac: clientData?.telephone || '',
              cPFac: clientData?.codePostal || '',
              villeFac: clientData?.ville || '',
              paysFac: clientData?.pays?.nom || '',
            })
          } else {
            // Si pas d'adresse de facturation alors prendre celui de la livraison
            // Si avec adresse de livraison alors le mettre dans la facturation
            // Récuperation de l'adresse de livraison s'il n'y a pas de facturation
            const lastAdresseLiv = (clientAdresseData?.facturation)
              ? clientAdresseData
              : adresseLivraisonOptions?.at(-1)

            if(setFacturationSelectedValue) setFacturationSelectedValue(transformToValueLabel(lastAdresseLiv))
            setUpdatedAdresseFactInfo({
              id: '',
              adresseFac: lastAdresseLiv?.adresse || '',
              complementAdresseFac: lastAdresseLiv?.complementAdresse || '',
              telephoneFac: lastAdresseLiv?.telephone || '',
              cPFac: lastAdresseLiv?.codePostal || '',
              villeFac: lastAdresseLiv?.ville || '',
              paysFac: lastAdresseLiv?.pays?.nom || '',
            })
          }
        }
      }
    }, [clientData, clientAdresses])

    // Séléction de l'adresse de facturation
    const handleSelectedFactChange = (e) => {
      const selectAdresse = adresseFacturationOptions?.find((adresse) => adresse.id === e.value)
      if(setFacturationSelectedValue) setFacturationSelectedValue(transformToValueLabel(selectAdresse))

      if (!setUpdatedAdresseFactInfo) return

      setUpdatedAdresseFactInfo({
        id: selectAdresse?.id || '',
        adresseFac: selectAdresse?.adresse || '',
        complementAdresseFac: selectAdresse?.complementAdresse || '',
        telephoneFac: selectAdresse?.telephone || '',
        cPFac: selectAdresse?.codePostal || '',
        villeFac: selectAdresse?.ville || '',
        paysFac: selectAdresse?.pays?.nom || '',
      })
    }

    // Transfromation du donnnée en value/label pour l'option de react-select
    const transformedDataFact = clientAdresses
      ?.filter((adresse) => adresse.facturation === true)
      ?.map((item) => ({
        value: item.id,
        label: item?.libelle ?? item.adresse,
      }))

    // Affichage des données d'adresse de facturation
    const displayFacturationAdresses = () => {
      return (
        <div
          className={`row mb-3 gap-3 align-items-center ${
            !fromDemandeForm ? 'justify-content-between' : ''
          }`}
        >
          {(isCreateOrUpdate) && (
            <div className={'col-auto'}>
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                data-bs-toggle="modal"
                data-bs-target="#modalAddAddress"
                onClick={() => (setClientAdresseEdit) ? setClientAdresseEdit(null) : null}
              >
                <KTIcon iconName='plus' className='fs-3' />
              </button>
            </div>
          )}
          <div className={'col'}>
            <Select
              className='react-select-styled react-select-solid react-select-lg min-w-200px'
              classNamePrefix='react-select'
              fieldName='facturation'
              options={transformedDataFact}
              value={transformedDataFact?.find((item) => item?.label == facturationSelectedValue?.label)}
              onChange={(e) => handleSelectedFactChange(e)}
              placeholder='Adresse de facturation'
              isDisabled={adresseFacturationOptions?.length <= 1 ? 'true' : ''}
            />
          </div>
          <input className={'d-none'} value={updatedAdresseFactInfo.id} name='id' />
          {fromDemandeForm ? (
            <>
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsFac?.adresseFac ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseFactInfo.adresseFac}
                onChange={handleAdressFactChange}
                placeholder={'Adresse'}
                name='adresseFac'
                disabled={isDisabled}
              />
              <input
                className={'col form-control form-control-lg form-control-solid mb-3 mb-lg-0 '}
                type={'text'}
                value={updatedAdresseFactInfo.complementAdresseFac}
                onChange={handleAdressFactChange}
                placeholder={'Complément adresse'}
                name='complementAdresseFac'
                disabled={isDisabled}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsFac?.telephoneFac ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseFactInfo.telephoneFac}
                onChange={handleAdressFactChange}
                placeholder={'Téléphone'}
                name='telephoneFac'
                disabled={isDisabled}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsFac?.cPFac ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseFactInfo.cPFac}
                onChange={handleAdressFactChange}
                placeholder={'Code postal'}
                name='cPFac'
                disabled={isDisabled}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsFac?.villeFac ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseFactInfo.villeFac}
                onChange={handleAdressFactChange}
                placeholder={'Ville'}
                name='villeFac'
                disabled={isDisabled}
              />
              <div
                className={`col form-control border-0 ${errorsFac?.paysFac ? 'is-invalid' : ''}`}
              >
                <Select
                  className='react-select-styled react-select-solid react-select-lg'
                  classNamePrefix='react-select'
                  fieldName='paysFac'
                  options={pays}
                  value={pays.find((item) => item.label == updatedAdresseFactInfo.paysFac)}
                  onChange={(option) => handleAdressFactChange(option, 'paysFac')}
                  placeholder='Pays'
                  disabled={isDisabled}
                />
              </div>
            </>
          ) : (
            <>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.adresseFac ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseFactInfo.adresseFac}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.complementAdresseFac ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>
                        {updatedAdresseFactInfo.complementAdresseFac}
                      </span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.telephoneFac ? (
                    <>
                      <i className='ki-duotone ki-telephone-geolocation fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseFactInfo.telephoneFac}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.cPFac ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseFactInfo.cPFac}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.villeFac ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseFactInfo.villeFac}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseFactInfo.paysFac ? (
                    <>
                      <i className='ki-duotone ki-bank fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseFactInfo.paysFac}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )
    }

    // Donnée à afficher par défaut
    // Fonctionnement:
    // Si le client n'a pas d'adresse Client, prendre les adresses du fiche client
    // Si le client a des adresses dans clientAdresse mais pas d'adresse de facturation ni livraison
    // Alors prendre celui du fiche client
    // Si l'une des deux adresses est absentes dans ClientAdresse
    // Alors prendre celui de la facturation ou de la livraison
    useEffect(() => {
      // Initialisation vide
      setUpdatedAdresseLivInfo({
        id: '',
        adresseFac: '',
        complementAdresseFac: '',
        telephoneFac: '',
        cPFac: '',
        villeFac: '',
        paysFac: '',
      })
      if (clientAdresses?.length == 0) {
        if (!setUpdatedAdresseLivInfo) return

        setUpdatedAdresseLivInfo({
          id: '',
          adresseLiv: clientData?.adresse,
          complementAdresseLiv: clientData?.complementAdresse || '',
          telephoneLiv: clientData?.telephone || '',
          cPLiv: clientData?.codePostal || '',
          villeLiv: clientData?.ville || '',
          paysLiv: clientData?.pays?.nom || '',
        })
      } else {
        if (!setUpdatedAdresseLivInfo) return

        if (adresseLivraisonOptions?.length !== 0) {
          //Récuperation de la dernière adresse
          const lastAdresse = (clientAdresseData && clientAdresseData?.livraison)
            ? clientAdresseData
            : adresseLivraisonOptions?.at(-1)

          if(setLivraisonSelectedValue) setLivraisonSelectedValue(transformToValueLabel(lastAdresse))

          setUpdatedAdresseLivInfo({
            id: lastAdresse?.id || '',
            adresseLiv: lastAdresse?.adresse || '',
            complementAdresseLiv: lastAdresse?.complementAdresse || '',
            telephoneLiv: lastAdresse?.telephone || '',
            cPLiv: lastAdresse?.codePostal || '',
            villeLiv: lastAdresse?.ville || '',
            paysLiv: lastAdresse?.pays?.nom || '',
          })
        } else {
          // S'il n'y a pas d'adresse de facturation
          // alors mettre celui du client dans l'adresse de livraison
          if (adresseFacturationOptions?.length == 0) {
            setUpdatedAdresseLivInfo({
              id: '',
              adresseLiv: clientData?.adresse || '',
              complementAdresseLiv: clientData?.complementAdresse || '',
              telephoneLiv: clientData?.telephone || '',
              cPLiv: clientData?.codePostal || '',
              villeLiv: clientData?.ville || '',
              paysLiv: clientData?.pays?.nom || '',
            })
          } else {
            const lastAdresseFac = (clientAdresseData?.livraison)
              ? clientAdresseData
              : adresseFacturationOptions?.at(-1)

            if(setLivraisonSelectedValue) setLivraisonSelectedValue(transformToValueLabel(lastAdresseFac))
            setUpdatedAdresseLivInfo({
              id: '',
              adresseLiv: lastAdresseFac?.adresse || '',
              complementAdresseLiv: lastAdresseFac?.complementAdresse || '',
              telephoneLiv: lastAdresseFac?.telephone || '',
              cPLiv: lastAdresseFac?.codePostal || '',
              villeLiv: lastAdresseFac?.ville || '',
              paysLiv: lastAdresseFac?.pays?.nom || '',
            })
          }
        }
      }
    }, [clientData, clientAdresses])

    // Séléction de l'adresse de livraison
    const handleSelectedLivChange = (e) => {
      const selectAdresse = adresseLivraisonOptions?.find((adresse) => adresse.id === e.value)
      if(setLivraisonSelectedValue) setLivraisonSelectedValue(transformToValueLabel(selectAdresse))

      if (!setUpdatedAdresseLivInfo) return

      setUpdatedAdresseLivInfo({
        id: selectAdresse?.id || '',
        adresseLiv: selectAdresse?.adresse || '',
        complementAdresseLiv: selectAdresse?.complementAdresse || '',
        telephoneLiv: selectAdresse?.telephone || '',
        cPLiv: selectAdresse?.codePostal || '',
        villeLiv: selectAdresse?.ville || '',
        paysLiv: selectAdresse?.pays?.nom || '',
      })
    }

    // Transfromation du donnnée en value/label pour l'option de react-select
    const transformedDataLiv = clientAdresses
      ?.filter((adresse) => adresse.livraison === true)
      ?.map((item) => ({
        value: item.id,
        label: item?.libelle ?? item.adresse,
      }))

    const handleChangeRetraitDepot = () => {
      setRetraitDepot(!retraitDepot)
      if (setPanier) {
        setPanier((prev) => prev.map((piece) => {
          if (piece.statut !== "PROPO" && piece.statut !== "A_PROPO") return piece
          const pieceExclue = !!clientData?.sauf?.some(item => item.label === piece.nomTypePieceProposee)
          const fraisOffert = !!clientData?.fraisPortOffert && !pieceExclue
          const fraisDePort = (fraisOffert || !retraitDepot) ? 0 : (piece?.fraisDePortInitial ?? 0)
          return {
            ...piece,
            fraisDePort: fraisDePort,
          }
        }))
        setInitialPieces((initialPieces) => {
          if (initialPieces.statut !== "PROPO" && initialPieces.statut !== "A_PROPO") return initialPieces
          return initialPieces?.map((item) => ({
            ...item,
            fraisDePort: !retraitDepot ? 0 : item?.fraisDePortInitial
          }))
        })
      }
    }

    // Affichage des données d'adresse de livraison
    const displayLivraisonAdresses = () => {
      return (
        <div
          className={`row mb-3 gap-3 align-items-center ${
            !fromDemandeForm ? 'justify-content-between' : ''
          }`}
        >
          {(isCreateOrUpdate) && (
            <div className={'col-auto'}>
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                data-bs-toggle="modal"
                data-bs-target="#modalAddAddress"
                onClick={() => (setClientAdresseEdit) ? setClientAdresseEdit(null) : null}
              >
                <KTIcon iconName='plus' className='fs-3' />
              </button>
            </div>
          )}
          <div className={'col'}>
            <Select
              className='react-select-styled react-select-solid react-select-lg min-w-200px'
              classNamePrefix='react-select'
              fieldName='livraison'
              options={transformedDataLiv}
              value={transformedDataLiv?.find((item) => item?.label == livraisonSelectedValue?.label)}
              onChange={(e) => handleSelectedLivChange(e)}
              placeholder='Adresse de livraison'
              isDisabled={(adresseLivraisonOptions?.length <= 1 || (retraitDepot !== undefined && retraitDepot)) ? 'true' : ''}
            />
          </div>

          <input className={'d-none'} value={updatedAdresseLivInfo.id} name='id' />
          {fromDemandeForm ? (
            <>
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsLiv?.adresseLiv ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseLivInfo.adresseLiv}
                onChange={handleAdressLivChange}
                placeholder={'Adresse'}
                name='adresseLiv'
                disabled={isDisabled || (retraitDepot !== undefined && retraitDepot)}
              />
              <input
                className={'col form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                type={'text'}
                value={updatedAdresseLivInfo.complementAdresseLiv}
                onChange={handleAdressLivChange}
                placeholder={'Complément adresse'}
                name='complementAdresseLiv'
                disabled={isDisabled || (retraitDepot !== undefined && retraitDepot)}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsLiv?.telephoneLiv ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseLivInfo.telephoneLiv}
                onChange={handleAdressLivChange}
                placeholder={'Téléphone'}
                name='telephoneLiv'
                disabled={isDisabled || (retraitDepot !== undefined && retraitDepot)}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsLiv?.cPLiv ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseLivInfo.cPLiv}
                onChange={handleAdressLivChange}
                placeholder={'Code postal'}
                name='cPLiv'
                disabled={isDisabled || (retraitDepot !== undefined && retraitDepot)}
              />
              <input
                className={`col form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                  errorsLiv?.villeLiv ? 'is-invalid' : ''
                }`}
                type={'text'}
                value={updatedAdresseLivInfo.villeLiv}
                onChange={handleAdressLivChange}
                placeholder={'Ville'}
                name='villeLiv'
                disabled={isDisabled || (retraitDepot !== undefined && retraitDepot)}
              />
              <div
                className={`col form-control border-0 ${errorsLiv?.paysLiv ? 'is-invalid' : ''}`}
              >
                <Select
                  className='react-select-styled react-select-solid react-select-lg'
                  classNamePrefix='react-select'
                  fieldName='paysLiv'
                  options={pays}
                  value={pays.find((item) => item.label == updatedAdresseLivInfo.paysLiv)}
                  onChange={(option) => handleAdressLivChange(option, 'paysLiv')}
                  placeholder='Pays'
                  isDisabled={(isDisabled || (retraitDepot !== undefined && retraitDepot)) ? 'true' : ''}
                />
              </div>
            </>
          ) : (
            <>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.adresseLiv ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseLivInfo.adresseLiv}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.complementAdresseLiv ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>
                        {updatedAdresseLivInfo.complementAdresseLiv}
                      </span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.telephoneLiv ? (
                    <>
                      <i className='ki-duotone ki-telephone-geolocation fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseLivInfo.telephoneLiv}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.cPLiv ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseLivInfo.cPLiv}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.villeLiv ? (
                    <>
                      <i className='ki-duotone ki-geolocation-home fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseLivInfo.villeLiv}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
              <div className={'col'}>
                <div className={'d-flex gap-3 align-items-center my-2'}>
                  {updatedAdresseLivInfo.paysLiv ? (
                    <>
                      <i className='ki-duotone ki-bank fs-2x'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      <span className={'text-gray-600'}>{updatedAdresseLivInfo.paysLiv}</span>
                    </>
                  ) : (
                    <span className={'text-gray-600 w-100 text-center'}>Nc</span>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )
    }

  // Si adresse de facturation == adresse de livraison
  // Si modifaction de l'une des deux adresses
  // Alors checké automatiquement Màj adresse
  useEffect(
    function automaticCheckIfEdited() {
      if (updatedAdresseFactInfo?.edited || updatedAdresseLivInfo?.edited) setIsAdresseUpdated(true)
    },
    [updatedAdresseFactInfo, updatedAdresseLivInfo]
  )

  useEffect(function closeAdresseOnLoad() {
    if (loadingAdresse)
      setShowAdresses(false)
  }, [loadingAdresse])

  return (
    <div className={'p-5 pt-0 pb-3'}>
      {/*Afficher le dropdown si seuelement les propriété de chaques adresse contiennent de la valeur*/}
      {(Object.values(updatedAdresseFactInfo).some((val) => val !== '') ||
        Object.values(updatedAdresseLivInfo).some((val) => val !== '')) && (
        <span
          className='d-flex align-items-center mb-1'
          onClick={() => {
            setShowAdresses(!showAdresses)
          }}
        >
          <hr className='flex-grow-1 text-muted' />
          <div className={`d-flex gap-2 text-primary fw-bold fs-6 mx-3 ${
            loadingAdresse ? 'cursor-default' : 'cursor-pointer'
          } align-items-center`}>
            Adresse de facturation / livraison{' '}
            {loadingAdresse ? (
              <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
            ) : showAdresses ? (
              <div className='d-flex align-items-center gap-2'>
                <i className='ki-duotone ki-up'></i>
              </div>
            ) : (
              <div className='d-flex align-items-center gap-2'>
                <i className='ki-duotone ki-down'></i>
              </div>
            )}
          </div>
          <hr className='flex-grow-1 text-muted' />
        </span>
      )}

      {showAdresses && (
        <div className={'px-5'}>
          <div className='d-flex flex-column'>
            <div className='mb-1'>
              <h5>Adresse de facturation</h5>
              <div>{displayFacturationAdresses()}</div>
            </div>
            <div className=''>
              <div className='d-flex justify-content-start gap-3'>
                <h5
                  className={`cursor-pointer ${(!retraitDepot) ? 'text-primary' : 'text-gray-400'}`}
                  onClick={() => setRetraitDepot(false)}
                >
                  Adresse de livraison
                </h5>
                <div className='form-check form-switch form-check-custom form-check-solid mt-n2 mx-2'>
                  <input
                    id='retraitDeport'
                    type='checkbox'
                    name='retraitDeport'
                    className='form-check-input h-20px w-35px cursor-pointer'
                    onChange={() => handleChangeRetraitDepot()}
                    checked={retraitDepot}
                  />
                </div>
                <h5
                  className={`cursor-pointer ${(retraitDepot) ? 'text-primary' : 'text-gray-400'}`}
                  onClick={() => setRetraitDepot(true)}
                >
                  Retrait dépôt demandé par le client
                </h5>
              </div>
              <div>{displayLivraisonAdresses()}</div>
            </div>
          </div>
          <div className={'d-flex gap-5 justify-content-end align-items-center my-3'}>
            {
              !fromDemandeForm && loadingDepot && (
                <div className={'d-flex gap-3 align-items-center text-muted'}>
                  <span className='spinner-border spinner-border-sm align-middle w-15px h-15px'></span>
                  <label className={''}>Chargement des adresses de retrait dépôt</label>
                </div>
              )
            }
            {fromDemandeForm && (
              <div className={'text-end form-check form-check-custom form-check-solid form-check-sm'}>
                <input
                  type={'checkbox'}
                  className={'form-check-input me-3'}
                  name={'checkbox-adresse'}
                  id={'checkbox-adresse'}
                  onChange={() => setIsAdresseUpdated(!isAdresseUpdated)}
                  checked={isAdresseUpdated ?? false}
                />
                <label htmlFor='checkbox-adresse' className='form-check-label text-gray-600 fs-6'>Mettre à jour les adresses du client</label>
              </div>
            )}
        </div>

        </div>
      )}
    </div>
  )
  }

export default AdresseClient
